// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__nkaNc","requiredAsterisk":"Info_requiredAsterisk__3ZWAj"};